/*
  Product switch (Cana Care) — see snippets/product-switch.liquid.

  Each row's radio carries a variant id. On change the product form's hidden
  variant input (and the installment form's) is pointed at that id, the same
  way VariantSelects.updateVariantInput and the selling plan widget do it, so
  "Læg i kurv" and the sticky button submit whichever product is selected.
*/
if (!customElements.get('product-switch')) {
  class ProductSwitch extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.section;
      this.radios = Array.prototype.slice.call(this.querySelectorAll('.spw-option__radio'));
      this.onChange = this.onChange.bind(this);
      this.radios.forEach((radio) => radio.addEventListener('change', this.onChange));

      const checked = this.radios.find((radio) => radio.checked) || this.radios[0];
      if (checked) this.apply(checked, false);
    }

    disconnectedCallback() {
      this.radios.forEach((radio) => radio.removeEventListener('change', this.onChange));
    }

    onChange(event) {
      this.apply(event.target, true);
    }

    apply(radio, dispatch) {
      const variantId = radio.value;
      if (!variantId) return;

      this.querySelectorAll('.spw-option').forEach((option) => {
        option.classList.toggle('spw-option--active', option.contains(radio));
      });

      ['product-form-' + this.sectionId, 'product-form-installment'].forEach((formId) => {
        const form = document.getElementById(formId);
        const input = form && form.querySelector('input[name="id"]');
        if (!input || input.value === variantId) return;
        input.value = variantId;
        if (dispatch) input.dispatchEvent(new Event('change', { bubbles: true }));
      });

      const sellingPlan = document.getElementById('product-form-selling-plan');
      if (sellingPlan) sellingPlan.value = '';

      const quantity = document.getElementById('Quantity-' + this.sectionId);
      if (quantity) quantity.value = 1;
    }
  }

  customElements.define('product-switch', ProductSwitch);
}
